// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://minside-dev.watercircles.no',
  bugsnagKey: '87c408f66b8e0b82f6f7f880eda8b6a0',
  brand: 'WATERCIRCLES',
  apiBrand: 'WATERCIRCLES',
  keycloak: {
    url: 'https://identitet-dev.watercircles.no/auth',
    realm: 'watercircles',
    clientId: 'client-app',
    loginRedirectPath: '/tilbud',
    idpHint: 'signicat-bankid-oidc'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
